<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>监控中心</el-breadcrumb-item>
          <el-breadcrumb-item>工单处理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="info">
            <div class="tab-content">
              <el-form label-width="120px">
                <el-form-item label="设备编号">{{ cabinetCode }}</el-form-item>
                <el-form-item label="公司名称">{{ companyName }}</el-form-item>
                <el-form-item label="工单名称">{{ title }}</el-form-item>
                <el-form-item label="问题描述">{{ description }}</el-form-item>
                <el-form-item label="工单图片">
                  <img
                    @click="largeImages(wordListImg, index)"
                    style="width: 100px; height: 100px; margin-right: 4px"
                    v-for="(itme, index) in wordListImg"
                    :key="index"
                    :src="baseApis + '/cabinet' + itme"
                    alt=""
                  />
                </el-form-item>
              </el-form>
              <el-form
                ref="editForm1"
                :model="model"
                :label-position="labelPosition"
                label-width="120px"
              >
                <el-form-item prop="mobile" label="处理时间">
                  <el-date-picker
                    :disabled="state == 1"
                    v-model="model.processingTime"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                    default-time="12:00:00"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item prop="processor" label="处理人">
                  <el-input
                    v-model="model.processor"
                    placeholder=""
                    :disabled="state == 1"
                  ></el-input>
                </el-form-item>

                <el-form-item label="处理过程图片" v-if="state != 1">
                  <el-upload
                    :action="uploadApi + '/cabinet/file/uploadImage'"
                    :headers="headers"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-success="handleSuccess"
                    :on-remove="handleRemove"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" />
                  </el-dialog>
                </el-form-item>
                <el-form-item label="处理过程图片" v-else>
                  <img
                    @click="largeImages(model.processingImgUrl, index)"
                    style="width: 100px; height: 100px; margin-right: 4px"
                    v-for="(itme, index) in model.processingImgUrl"
                    :key="index"
                    :src="baseApis + '/cabinet' + itme"
                    alt=""
                  />
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-dialog :visible.sync="largeImage">
        <i class="left_i el-icon-arrow-left" @click="changeLeft()"></i>
        <i class="left_r el-icon-arrow-right" @click="changeRight()"></i>
        <img
          style="
            min-height: 300px;
            max-height: 600px;
            border: 1ox solid #eee;
            margin: 10px auto;
          "
          v-for="(pic, index) in largeImageList"
          v-show="imgIndex == index"
          :key="index"
          width="100%"
          :src="baseApis + '/cabinet' + pic"
          alt=""
        />
      </el-dialog>

      <div class="footer-box">
        <div class="footer-btn" v-if="state != 1">
          <el-button type="primary" @click="submitForm">确认保存</el-button>
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../js/upload.component.js";
import { AxiosAjax, uploadApi, baseApi } from "../../js/axios.config";
export default {
  data() {
    return {
      largeImageList: [],
      imgIndex: 0,
      largeImage: false,
      baseApis: "",
      fits: ["fill", "contain", "cover", "none", "scale-down"],
      headers: { Authorization: "" },
      uploadApi: uploadApi,
      dialogImageUrl: "",
      dialogVisible: false,
      mobile: "",
      cabinetCode: "",
      companyName: "",
      title: "",
      description: "",
      state: 0,
      fileList: [],

      disabled: true,
      activeName: "info", //当前选项卡
      labelPosition: "right", //表单对齐方式
      model: {
        id: "",
        processingImgUrl: [],
        processingTime: "",
        processor: "",
      },
      wordListImg: [],
    };
  },
  mounted() {
    this.baseApis = baseApi;
    this.headers.Authorization = localStorage.getItem("fx_client_access_token");
  },
  methods: {
    changeLeft() {
      const _this = this;
      if (_this.imgIndex == 0) {
        _this.imgIndex = _this.largeImageList.length - 1;
        return;
      }
      _this.imgIndex--;
    },
    changeRight() {
      const _this = this;
      _this.imgIndex++;
      if (_this.imgIndex >= _this.largeImageList.length) {
        _this.imgIndex = 0;
      }
    },
    largeImages(data, i) {
      const _this = this;
      _this.largeImage = !_this.largeImage;
      _this.imgIndex = i;
      _this.largeImageList = data;
    },
    handleRemove(file, fileList) {
      this.model.processingImgUrl = [];
      fileList.forEach((el) => {
        this.model.processingImgUrl.push(el.response.data.relativePath);
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = false;
    },
    handleSuccess(file, fileList) {
      this.model.processingImgUrl.push(file.data.relativePath);
    },
    //初始化数据
    initData: function () {
      let _this = this; //当前页面
      // //加载设备
      AxiosAjax({
        url: "/cabinet/workOrder/" + _this.$route.query.id,
        loading: true,
        success: function (res) {
          _this.cabinetList = res.data.data;
          _this.cabinetCode = res.data.data.cabinetCode;
          _this.companyName = res.data.data.companyName;
          _this.title = res.data.data.title;
          _this.description = res.data.data.description;
          _this.model.id = res.data.data.id;
          _this.model.processingTime = res.data.data.processingTime || "";
          _this.model.processingImgUrl =
            res.data.data.processingImgUrlList || [];
          _this.model.processor = res.data.data.processor || "";
          _this.state = res.data.data.state || 0;
          _this.wordListImg = res.data.data.imgUrlList || [];
        },
      });
    },
    submitForm: function () {
      let _this = this; //当前页面

      AxiosAjax({
        method: "put",
        url: "/cabinet/workOrder/update",
        data: _this.model,
        loading: true,
        successMsg: "工单处理成功",
        success: function (res) {
          //重置表单
          _this.$router.push({ name: "WorkOrderList" });
        },
      });
    },
    resetForm() {
      window.history.back(-1);
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
};
</script>
<style scoped>
.left_i {
  position: absolute;
  left: 10px;
  font-size: 70px;
  z-index: 200;
  top: 50%;
  width: 70px;
  height: 70px;
  margin-top: -35px;
  color: #eee;
  opacity: 0.5;
  cursor: pointer;
}
.left_r {
  position: absolute;
  right: 10px;
  font-size: 70px;
  z-index: 200;
  top: 50%;
  width: 70px;
  height: 70px;
  margin-top: -35px;
  color: #eee;
  opacity: 0.5;
  cursor: pointer;
}
.content-box {
  text-align: left !important;
}
textarea {
  width: 100%;
  height: 200px;
  border: 1px solid #dcdfe6;
}
.content-box .el-form-item__content img {
  object-fit: contain;
  border: 1px solid #eee;
}
.content-box
  /deep/
  .el-upload-list--picture-card
  .el-upload-list__item-thumbnail {
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/WorkOrder/WorkOrderHandle.vue